import { cssEscape } from "./dom-helpers.js";
import { patchHTML } from "./surface-host.js";

export function captureThreadSurfaceState(container, options = {}) {
  if (!(container instanceof Element)) {
    return null;
  }
  const conversationEl = container.querySelector(".conversation-scroll");
  const savedScroll = conversationEl ? conversationEl.scrollTop : null;
  const wasNearBottom = conversationEl
    ? (conversationEl.scrollHeight - conversationEl.scrollTop - conversationEl.clientHeight < 300)
    : true;
  const active = options.activeElement instanceof Element ? options.activeElement : null;
  let composer = null;
  if (active instanceof HTMLTextAreaElement && container.contains(active)) {
    const form = active.closest("#thread-message-form");
    if (form instanceof HTMLFormElement) {
      composer = {
        threadID: form.getAttribute("data-thread-id") || "",
        selectionStart: typeof active.selectionStart === "number" ? active.selectionStart : null,
        selectionEnd: typeof active.selectionEnd === "number" ? active.selectionEnd : null,
        selectionDirection: typeof active.selectionDirection === "string" ? active.selectionDirection : "none"
      };
    }
  }
  let contextFilter = null;
  if (active instanceof HTMLInputElement && active.name === "context_filter_text" && container.contains(active)) {
    contextFilter = {
      selectionStart: typeof active.selectionStart === "number" ? active.selectionStart : null,
      selectionEnd: typeof active.selectionEnd === "number" ? active.selectionEnd : null,
      selectionDirection: typeof active.selectionDirection === "string" ? active.selectionDirection : "none"
    };
  }
  return { savedScroll, wasNearBottom, composer, contextFilter };
}

export function restoreThreadSurfaceState(container, snapshot) {
  if (!(container instanceof Element) || !snapshot) {
    return;
  }
  const conversationEl = container.querySelector(".conversation-scroll");
  if (conversationEl) {
    if (snapshot.savedScroll !== null && !snapshot.wasNearBottom) {
      conversationEl.scrollTop = snapshot.savedScroll;
    } else {
      conversationEl.scrollTop = conversationEl.scrollHeight;
    }
  }
  const composer = snapshot.composer || null;
  const contextFilter = snapshot.contextFilter || null;
  if (contextFilter) {
    const nextFilter = container.querySelector(`input[name="context_filter_text"]`);
    if (nextFilter instanceof HTMLInputElement) {
      nextFilter.focus({ preventScroll: true });
      if (typeof contextFilter.selectionStart === "number" && typeof contextFilter.selectionEnd === "number") {
        nextFilter.setSelectionRange(contextFilter.selectionStart, contextFilter.selectionEnd, contextFilter.selectionDirection || "none");
      }
      return;
    }
  }
  if (!composer?.threadID) {
    return;
  }
  const nextField = container.querySelector(`#thread-message-form[data-thread-id="${cssEscape(composer.threadID)}"] textarea[name="prompt"]`);
  if (!(nextField instanceof HTMLTextAreaElement)) {
    return;
  }
  nextField.focus({ preventScroll: true });
  if (typeof composer.selectionStart === "number" && typeof composer.selectionEnd === "number") {
    nextField.setSelectionRange(composer.selectionStart, composer.selectionEnd, composer.selectionDirection || "none");
  }
}

export function patchThreadSurfaceHTML(container, html, options = {}) {
  const snapshot = captureThreadSurfaceState(container, options);
  patchHTML(container, html);
  restoreThreadSurfaceState(container, snapshot);
}
